import { render, staticRenderFns } from "./veJkyFundMy.vue?vue&type=template&id=18188feb&scoped=true"
import script from "./veJkyFundMy.vue?vue&type=script&lang=js"
export * from "./veJkyFundMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18188feb",
  null
  
)

export default component.exports